import {FormControl, FormGroup, ValidatorFn} from "@angular/forms";
import {TemplateRef} from "@angular/core";
import {Globals} from "../shared/Globals";

export function ColDefDefault(col: ColDef){
  let def = col.default || null;
  if(typeof def !== null){
    if(col.type === ColType.RANGE){
      def = {
        start: Globals.fromDateString(def.start),
        end: Globals.fromDateString(def.end)
      };
    }
    else if(col.type === ColType.DATE){
      def = Globals.fromDateString(def);
    }
  }
  return def;
}

export interface ColDef{
  title: string,
  subtitle?: string,
  name: string,
  target?: string,  // LISTADDER only: explicit search target; defaults to `name` when omitted
  type: ColType,
  length?: number,
  required: boolean,
  disabled?: boolean,
  default?: any,
  style?: object,
  list?: ListEntry[],
  multiple?: boolean,  // For SELECT type: allow multiple selections
  range?: {gte: number|Date|null, lte: number|Date|null},
  sort?: string[]|boolean|string,
  sortindex?: number,
  filter?: boolean|string,
  stickyWidth?: number,  // fixed px width of a sticky-right column
  gridTrack?: string,  // experimentalGrid only: this column's grid track; default minmax(125px, max-content)
  validators?: ValidatorFn[],
  display?: string|((value: any) => string)|TemplateRef<any>,
  form?: FormControl|FormGroup,
  colDefs?: ColDef[],
  group?: any,
  noexport?: boolean,
  hint?: string,  // muted helper text rendered under the control in edit dialogs
  action?: ColAction  // SELECT + LISTADDER: action.handler wires "add new"; action.label renders only for SELECT (LISTADDER uses list-adder's own addnew i18n row)
}

/** Inline action under a SELECT in edit dialogs (e.g. "+ New client"). The
 *  resolved entry is appended to col.list and selected; null means cancelled. */
export interface ColAction{
  label: string,
  handler: () => Promise<ListEntry|null>
}

export enum ColType{
  AREA = 'textarea',
  STRING = 'string',
  RANGE = 'range',
  INT = 'int',
  SELECT = 'select',
  BOOL = 'bool',
  RADIO = 'radio',
  DATE = 'date',
  SEARCH = 'search',
  CURRENCY = 'currency',
  PHONE = 'phone',
  LOCATION = 'location',
  LISTADDER = 'listadder',
  SLIDER = 'slider',
  FILE = 'file',
  SCALE = 'scale',
  TIME = 'time',
  CUSTOM = '_custom'
}

export interface ListEntry{
  id: string|number,
  name: string
}

export interface Delete{
  deleted: boolean,
  moved?: boolean|number
}
